import { createAsyncThunk } from '@reduxjs/toolkit';

import { fetchProductReviewsClient } from 'src/services/product-reviews/fetchProductReviewsClient';
import type { ReviewsPage } from 'src/services/product-reviews/types';
import { fetchProductReviews } from 'src/services/rar-data-api/fetchProductReviews';
import type { RarDataAPIResponse } from 'src/services/rar-data-api/types/RarDataAPIResponse';
import { fetchReviewSummary } from 'src/services/reviews-summary-api/fetchReviewSummary';
import type { ReviewSummaryResponse } from 'src/services/reviews-summary-api/types/ReviewSummaryResponse';
import type { ReviewRatingFilter } from './types';

export interface RequestProductReviewsOptions {
  autoInitiated?: boolean;
  page: number;
  perPage?: number;
  productCode: number;
}

export const requestProductReviews = createAsyncThunk<
  RarDataAPIResponse,
  RequestProductReviewsOptions
>('productReviews/requestProductReviews', async ({ page, perPage, productCode }) => {
  const data = await fetchProductReviews(productCode, { page, perPage });

  return data;
});

export interface RequestReviewsSummaryOptions {
  productCode: number;
}

export const requestAiSummary = createAsyncThunk<
  ReviewSummaryResponse | null,
  RequestReviewsSummaryOptions
>('reviews/requestAiSummary', ({ productCode }) => fetchReviewSummary(productCode));

export interface RequestReviewsPageOptions {
  /** A fetch the page makes itself, which the live region does not announce. */
  autoInitiated?: boolean;
  page: number;
  productCode: number;
  /** Star filter, 1 to 5, or null/undefined for all ratings. */
  rating?: ReviewRatingFilter;
}

/**
 * A page of the Feefo reviews list, through our own API route. The first page also carries
 * the rating breakdown and partner insights for the summary section and the drawer.
 */
export const requestReviewsPage = createAsyncThunk<ReviewsPage | null, RequestReviewsPageOptions>(
  'reviews/requestReviewsPage',
  ({ page, productCode, rating = null }) =>
    fetchProductReviewsClient(productCode, { page, rating }),
);
